import { Avatar, createStyles, Grid, makeStyles } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import { StyledButton } from "../styled-button/StyledButton";
import FolderIcon from "@material-ui/icons/Folder";
import PublishIcon from "@material-ui/icons/Publish";
import React from "react";
import ErrorIcon from "@material-ui/icons/Error";

const useStyles = makeStyles(() =>
  createStyles({
    dropzone: {
      cursor: "pointer",
      padding: "1rem",
      background: "#6f6f6f3b",
      borderRadius: "1rem",
    },
    fileList: {
      margin: "1rem 0",
      background: "#d3dafd40",
      padding: "1rem 1rem",
      listStyle: "none",
      borderRadius: "1rem",
      fontWeight: "600",
    },
    formats: {
      fontSize: "11px",
      padding: "7px",
      color: "#ffffff61",
    },
  })
);

const FilePicker = (props) => {
  const classes = useStyles();

  const { updateFileUrl, formats, types } = props;
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    onDropAccepted: (files) =>
      files.map((file) => {
        const fileType = file.name.split(".").pop();
        const isValidFile = types.includes(fileType);
        setIsValidUpload(isValidFile);
      }),
  });

  const [isValidUpload, setIsValidUpload] = React.useState(false);

  const updateModel = () => {
    if (acceptedFiles.length !== 0 && isValidUpload) {
      const fileType = acceptedFiles[0].name.split(".").pop();
      const fileUrl = URL.createObjectURL(acceptedFiles[0]);
      updateFileUrl({ src: fileUrl, type: fileType });
    }
  };

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      <Grid container>
        <Grid item xs={2}>
          <Avatar>
            {isValidUpload ? <FolderIcon /> : <ErrorIcon color="secondary" />}
          </Avatar>
        </Grid>
        <Grid item xs={10} style={{ wordBreak: "break-all" }}>
          {isValidUpload ? (
            <>
              {file.path} - {(file.size / 1024).toFixed(2)} kb
            </>
          ) : (
            "Please upload a valid file"
          )}
        </Grid>
      </Grid>
    </li>
  ));

  return (
    <div className="chat-addons">
      <div className="file-picker">
        <div {...getRootProps({ className: classes.dropzone })}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop some files here, or click to select files</p>
        </div>
        <span className={classes.formats}>Formats supported: {formats}</span>
        <aside>
          {acceptedFiles.length !== 0 && (
            <ul className={classes.fileList}>{files}</ul>
          )}
        </aside>
        <div className={"file-actions mt-2"}>
          <StyledButton
            variant={"contained"}
            color="primary"
            onClick={() => updateModel()}
            startIcon={<PublishIcon />}
          >
            Upload
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

export default FilePicker;
